"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgIncludedServices = function SvgIncludedServices(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 160 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica",
    fontSize: 14,
    fill: "#4D4D4D",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 16
  }, '+')), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica",
    fontSize: 14,
    fill: "#4D4D4D",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 79,
    y: 16
  }, '+')), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica",
    fontSize: 14,
    fill: "#4D4D4D",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 127,
    y: 16
  }, '+')), /*#__PURE__*/React.createElement("path", {
    d: "m56.401 13.125-4.803 2.984s-1.275 1.005-3.679.503c-2.404-.503-4.87-1.054-4.87-1.054s-.529-.195-.894.283c-.364.479.236.764.236.764l3.708 2.722s.79.793 1.956.585c1.165-.209 4.59-.913 4.59-.913s2.337-.506 5.117-2.263S70.48 8.867 70.48 8.867s3.868-2.227 3.48-3.16c-.387-.932-2.617-.683-3.683-.341-1.066.341-9.388 5.12-9.388 5.12l-9.12-3.168s-1.18-.284-.59.414 6.368 6.525 6.368 6.525m3.949 2.802 2.478 2.503s.72.578.864-1.432c.145-2.011.292-3.516.292-3.516",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 5)",
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.504 14.741H2.521s-2.017.174-2.017-2.007V2.354S.65.386 2.481.386h19.2s2.565-.046 3.036 2.407c.472 2.453.861 4.624.861 4.624s2.39.577 2.39 2.332v3.522s-.955 1.436-2.444 1.436c-1.489 0-10.02.034-10.02.034z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 5.786,
    cy: 14.532,
    rx: 2.48,
    ry: 2.468
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 23.316,
    cy: 14.532,
    rx: 2.48,
    ry: 2.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5a.5.5 0 0 0-.5.5v3.644a.5.5 0 0 0 .5.5h2.564a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4zm6 0a.5.5 0 0 0-.5.5v3.644a.5.5 0 0 0 .5.5h2.564a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H10zm6 0a.5.5 0 0 0-.5.5v3.644a.5.5 0 0 0 .5.5h2.564a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H16z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.657 3.063h-1.713s-.774-.011-.774.77v2.742s-.222.803.807.803h2.79"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.034 4.287s.411 14.575 10.08 18.888c10.117-4.313 9.421-19.278 9.421-19.278s-5.964-.263-7.738-1.664c-1.775-1.4-2.024-1.633-3.639 0-1.614 1.633-8.124 2.054-8.124 2.054zM149 8.36v7.13m-3.636-3.45h6.923",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.327 4.887v2.097h2.06V4.887h-2.06zm4.336 0h2.061v2.097h-2.06zm-4.337 4.13v2.096h2.062V9.016H4.327zm4.337 0h2.061v2.096h-2.06zm-4.337 4.386V15.5h2.062v-2.097H4.327zm4.337 0h2.061V15.5h-2.06zm5.868-8.516h2.06v2.097h-2.06zm4.336 0h2.061v2.097h-2.06zm-4.336 4.13h2.06v2.096h-2.06zm4.336 0h2.061v2.096h-2.06zm-4.336 4.386h2.06V15.5h-2.06zm4.336 0h2.061V15.5h-2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.286 21.5h8.088v-4.032h4.554V21.5h8.297V2.855h1.225V1.578H.687v1.277h1.599V21.5z"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgIncludedServices);
var _default = Memo;
exports["default"] = _default;